import Component from './beneficial-owner-page';
export default Component;
